"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updatePrintableGroupOrder = void 0;
const either_1 = require("../../types/either");
const updatePrintableGroupOrder = (project, action) => {
  const newPrintableGroup = project.printableGroups.find(pg => pg.type === 'interior');
  if (!newPrintableGroup) {
    return (0, either_1.left)(new Error('We could not find any printable group of type interior'));
  }
  if (!(action.printables.length === newPrintableGroup.printables.length)) {
    return (0, either_1.left)(new Error(`The length of printables array in the request does not match with the quantity of printables in printableGroup with id ${newPrintableGroup.id}`));
  }
  const notFoundIds = [];
  const printables = [];
  action.printables.forEach(printableId => {
    const printable = newPrintableGroup.printables.find(p => p.id === printableId);
    if (printable) {
      printables.push(printable);
    } else {
      notFoundIds.push(printableId);
    }
  });
  if (notFoundIds.length > 0) {
    return (0, either_1.left)(new Error(`The id/ids ${notFoundIds.toString()} don't match with any id in printableGroup with id ${newPrintableGroup.id}`));
  }
  const pgIndex = project.printableGroups.findIndex(pg => pg.type === 'interior');
  project.printableGroups[pgIndex].printables = printables;
  return (0, either_1.right)(project);
};
exports.updatePrintableGroupOrder = updatePrintableGroupOrder;